/* trademarks: the portfolio list (`tm`), one trademark's dossier (`tmd`) and
 * the add form (`tmAdd`) — translated in the Wave 3 pass (2026-09-30). */
export default {
  tm: {
    title: 'Моите марки',
    subtitle:
      'Наблюдавани марки, юрисдикции, правен статус и дейност по наблюдението на едно място.',
    filters: 'Филтри',
    add: 'Добави марка',
    kpi: {
      label: 'Обзор на портфолиото',
      total: 'Общо марки',
      thisMonth: 'този месец',
      noneThisMonth: 'Няма добавени този месец',
      monitored: 'Активно наблюдение',
      ofPortfolio: 'от портфолиото е под наблюдение',
      openMatches: 'Съвпадения за преглед',
      openMatchesHint: 'В цялото портфолио',
      openMatchesNone: 'Нищо не чака',
      registries: 'Обхванати регистри',
      registriesNone: 'Няма настроено наблюдение',
    },
    filter: {
      search: 'Търсене',
      searchPlaceholder: 'Марка или притежател',
      monitoring: 'Наблюдение',
      monitored: 'Наблюдавани',
      notMonitored: 'Ненаблюдавани',
      registry: 'Регистър',
      noRegistries: 'Все още няма настроени регистри.',
      classes: 'Класове по Ница',
      classesHint: 'Класовете на тази страница, най-честите първи.',
      type: 'Вид марка',
      reset: 'Изчисти',
      apply: 'Приложи',
    },
    chip: {
      registry: 'Регистър: {code}',
      class: 'Клас {n}',
      search: 'Търсене: {q}',
    },
    sort: {
      label: 'Подреди марките',
      title: 'Име (А–Я)',
      titleDesc: 'Име (Я–А)',
      recent: 'Последно добавени',
      registered: 'Дата на регистрация, най-новите първи',
      expiring: 'Дата на изтичане, най-ранните първи',
    },
    bulk: {
      confirmTitle: 'Да се изтрие ли {n} марка? | Да се изтрият ли {n} марки?',
      cannotUndo: 'Това действие е необратимо.',
      goesWith:
        'Заедно с тях се изтриват обхватът на наблюдение, документите и историята на съвпаденията.',
      partial: 'Изтрити {done} от {n}',
      partialSub: '{n} не можа да бъде изтрита. | {n} не можаха да бъдат изтрити.',
      done: 'Изтрита е {n} марка | Изтрити са {n} марки',
    },
    shown: '{n} от {total} марка | {n} от {total} марки',
    filtersActive: '{n} активен филтър | {n} активни филтъра',
    searchPlaceholder: 'Търсене на марки…',
    col: {
      trademark: 'Марка',
      owner: 'Притежател',
      juris: 'Държава',
      classes: 'Класове',
      monitoring: 'Наблюдение',
      status: 'Статус',
      review: 'Преглед',
    },
    empty: {
      title: 'Няма марки, отговарящи на филтрите',
      message: 'Премахнете избрания регистър или клас или потърсете друго име.',
      reset: 'Изчисти филтрите',
    },
    page: {
      showing: 'Показани',
      ofTotal: 'от {total} марка | от {total} марки',
      prev: 'Предишна страница',
      next: 'Следваща страница',
    },
    preview: {
      label: 'Преглед на избраната марка',
      noNumber: 'Без номер',
      reg: 'Рег. {date}',
      close: 'Затвори прегледа',
      owner: 'Притежател',
      country: 'Държава',
      watchedOn: 'Наблюдава се в',
      pausedOn: 'Спряно: {list}',
      classes: 'Класове по Ница',
      type: 'Вид',
      status: 'Статус',
      monitoring: 'Наблюдение',
      awaiting: 'съвпадение чака преглед | съвпадения чакат преглед',
      openCases: '{n} открито дело | {n} открити дела',
      dossier: 'Към досието на марката',
      openMonitoring: 'Към наблюдението',
    },
    monitoring: {
      active: 'Активно наблюдение',
      paused: 'Наблюдението е спряно',
      none: 'Не се наблюдава',
    },
    monitoringTag: {
      active: 'Активно',
      paused: 'Спряно',
      none: 'Не се наблюдава',
    },
    row: {
      select: 'Избери {name}',
      logoAlt: 'Лого на {name}',
      toReview: '{n} за преглед',
      clear: 'Няма',
      open: 'Отвори досието на марката',
    },
    status: {
      registered: 'Регистрирана',
      pending: 'Висяща',
      opposition: 'Опозиция',
      under_review: 'На разглеждане',
      filed: 'Заявена',
      published: 'Публикувана',
      opposed: 'С подадена опозиция',
      cancellation_procedure: 'Заличаване',
      expired: 'Изтекла',
      refused: 'Отказана',
      withdrawn: 'Оттеглена',
    },
    type: {
      wordmark: 'Словна',
      figurative: 'Фигуративна',
      combined: 'Комбинирана',
      sound: 'Звукова',
      other: 'Друга',
    },
  },

  tmd: {
    back: 'Обратно към портфолиото',
    logoAlt: 'Лого на {name}',
    eyebrow: 'Защитена марка',
    toReviewTitle: 'Съвпадения, открити от ИИ, които още никой не е прегледал',
    regShort: 'Рег.',
    monitoring: 'Наблюдение с ИИ',
    monitoringActive: 'Активно · {list}',
    uploading: 'Качване…',
    upload: 'Качи документ',
    openMonitoring: 'Към наблюдението',
    createOpposition: 'Открий дело по опозиция',
    label: 'Досие на марката',
    sections: 'Раздели на досието',
    tab: {
      overview: 'Обзор',
      monitoring: 'Наблюдение',
      matches: 'Съвпадения',
      oppositions: 'Опозиции',
      documents: 'Документи',
    },
    details: {
      title: 'Данни за регистрацията',
      type: 'Вид марка',
      country: 'Държава на регистрация',
      number: '№ на регистрация или заявка',
      status: 'Статус',
      filed: 'Заявена',
      registered: 'Регистрирана',
      expires: 'Изтича',
      owner: 'Притежател',
      classes: 'Класове по Ница',
      description: 'Описание',
    },
    scopes: {
      title: 'Обхват на наблюдението',
      count: '{n} регистър | {n} регистъра',
      emptyTitle: 'Тази марка не се наблюдава',
      empty:
        'За тази марка не е избран регистър, затова новите публикации не се проверяват срещу нея.',
      registry: 'Регистър',
      state: 'Състояние',
      lastScan: 'Последна проверка',
      active: 'Активно',
      paused: 'Спряно',
      awaiting: 'Очаква първа проверка (три месеца назад)',
      never: 'Не е проверявана',
      feedFallback: 'Източник {id}',
    },
    matches: {
      title: 'Свързани съвпадения',
      awaiting: '{n} за преглед',
      found: 'Открита марка',
      registry: 'Регистър',
      decidedBy: 'Решено от',
      risk: 'Риск',
      window: 'Срок',
      rule: 'По правило',
      review: 'Преглед',
      emptyTitle: 'Няма открити съвпадения за тази марка',
      empty:
        'Сред публикуваното в наблюдаваните регистри все още не е открито нищо сходно с тази марка.',
      more: 'Показани са {n} с най-близък срок за опозиция. Останалите са на страницата за наблюдение, под тази марка.',
      closesToday: 'Изтича днес',
      closedDays: 'Изтекъл преди {n} ден | Изтекъл преди {n} дни',
      closedMonths: 'Изтекъл преди {n} месец | Изтекъл преди {n} месеца',
      closedYears: 'Изтекъл преди {n} година | Изтекъл преди {n} години',
    },
    docs: {
      title: 'Документи',
      count: '{n} файл | {n} файла',
      emptyTitle: 'Все още няма документи',
      empty:
        'Тук се съхраняват свидетелства за регистрация, доказателства за използване и кореспонденция.',
      uploadFirst: 'Качи файл',
      file: 'Файл',
      kind: 'Вид',
      size: 'Размер',
      added: 'Добавен',
      remove: 'Изтрий {name}',
      rejected: 'отхвърлен',
      notUploaded: '{n} файл не беше качен | {n} файла не бяха качени',
      uploaded: 'Качен е {n} файл | Качени са {n} файла',
      confirmTitle: 'Да се изтрие ли {name}?',
      confirmBody: 'Файлът се изтрива окончателно. Това действие е необратимо.',
      deleted: 'Файлът е изтрит',
      deleteFailed: 'Файлът не можа да бъде изтрит',
    },
    rail: {
      label: 'Обобщение на защитата',
      title: 'Обобщение на защитата',
      watchedOn: 'Наблюдава се в',
      none: 'Няма',
      classes: 'Класове по Ница',
      noneRecorded: 'Няма записани',
      toReview: 'Съвпадения за преглед',
      openCases: 'Открити дела',
    },
  },

  tmAdd: {
    crumb: 'Добавяне на марка',
    title: 'Добавяне на марка',
    subtitle: 'Въведете марка, която защитавате, и изберете в кои регистри да се търсят конфликти.',
    creating: 'Създаване…',
    create: 'Създай марката',
    loadFailed: 'Неуспешно зареждане: {list}.',
    failedPart: {
      clients: 'клиенти',
      registries: 'регистри',
      classes: 'класове по Ница',
    },
    workspace: 'Добавяне на марка',
    required: 'Задължително',
    example: 'напр. {value}',
    err: {
      title: 'Името на марката е задължително',
      titleShort: 'Поне {n} знака',
      client: 'Изберете клиента, който притежава марката',
      country: 'Държавата на регистрация е задължителна',
      type: 'Изберете вид марка',
      classes: 'Изберете поне един клас по Ница',
      incomplete: 'Попълнете задължителните полета',
    },
    mark: {
      title: 'Марката',
      sub: 'Какво се защитава и кой е притежателят.',
      name: 'Име на марката',
      namePlaceholder: 'Марката, както е заявена',
      country: 'Държава на регистрация',
      countryPick: 'Изберете държава…',
      countryHint: 'Определя кой национален регистър може да се наблюдава.',
      owner: 'Притежател (клиент)',
      ownerPick: 'Изберете клиент…',
      clientCount:
        '{n} клиент във вашето работно пространство | {n} клиента във вашето работно пространство',
      addClient: 'добавете нов',
      type: 'Вид марка',
      description: 'Описание',
      descriptionPlaceholder:
        'Стоките и услугите със свои думи или всичко, което следващият колега трябва да знае.',
    },
    typeHint: {
      word: 'Само текст — защитава се самото име.',
      figurative: 'Лого или изображение без думи.',
      combined: 'Думи и изображение заедно.',
      sound: 'Мелодия или звуков знак.',
      other: 'Форма, цвят, движение, позиция.',
    },
    registration: {
      title: 'Регистрация',
      sub: 'По избор — марката може да се наблюдава и преди да бъде регистрирана.',
      application: '№ на заявката',
      registration: '№ на регистрацията',
      filed: 'Дата на заявяване',
      registered: 'Дата на регистрация',
      expires: 'Дата на изтичане',
    },
    scopes: {
      title: 'Къде да се наблюдава',
      sub: 'Всеки избран регистър се проверява за конфликти с тази марка.',
      selected: '{n} избран | {n} избрани',
      hint: 'Марка без избран регистър се съхранява, но никога не се проверява.',
      inactive: 'В момента не е активен',
      countryFirst: 'Първо изберете държава',
      onlyFor: 'Само за марки с държава {code}',
      noSource: 'Фирмата ви няма настроен източник за този регистър',
    },
    feedKind: {
      world: 'Международни (Мадридска система)',
      europe: 'Европейски съюз',
      national: 'Национално ведомство',
    },
    classes: {
      title: 'Класове по Ница',
      sub: 'Стоките и услугите, за които е марката. Конфликтите се преценяват в тях.',
      search: 'Търсете сред всички 45 класа по номер или текст…',
      searchLabel: 'Търсене на класове по Ница',
    },
    next: {
      label: 'Насоки',
      title: 'Какво следва',
      now: 'Веднага.',
      nowText: 'Марката се записва към клиента си и се появява в портфолиото.',
      scan: 'Първа проверка.',
      scanText:
        'Всеки нов обхват започва с проверка три месеца назад — срокът за опозиция — така че нищо вече публикувано не се пропуска.',
      after: 'След това.',
      afterText: 'Качете свидетелството за регистрация и доказателствата в досието на марката.',
    },
    actions: 'Действия с формата',
    unsaved: 'Нищо не се записва, докато не създадете марката.',
    created: 'Марката е създадена',
    createdWatched:
      '{name} вече се наблюдава в {n} регистър. | {name} вече се наблюдава в {n} регистъра.',
    createdUnwatched: '{name} е добавена. Все още не е избран обхват на наблюдение.',
    createFailed: 'Марката не можа да бъде създадена',
  },
} as const
